import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.535 14.998s1.247-1.861 1.24-3.457c-.107-1.516 2.371 1.978 1.998 3.552 0 0 1.697-.584 1.524-1.678s2.837 2.171-.378 5.1c-1.908 1.74-6.755 1.388-7.655-3.026-.9-4.415 2.437-4.398 2.93-11.59 0 0 3.197.849 4.044 4.505.848 3.656.585 3.222 1.82 1.611 1.233-1.61 1.28-2.447 1.818-1.83.538.618 2.69 4.85 1.513 7.135"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.534 14.999s1.248-1.862 1.24-3.457c-.106-1.517 2.372 1.978 1.999 3.552 0 0 1.697-.585 1.523-1.679-.173-1.094 2.838 2.172-.377 5.1-1.909 1.74-6.755 1.389-7.656-3.026"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      d="M5.139 7.55a.58.58 0 1 0 .064-1.159.58.58 0 0 0-.064 1.159M15.188 4.425a.58.58 0 1 0 .064-1.159.58.58 0 0 0-.064 1.159M19.283 7.46a.58.58 0 1 0 .064-1.158.58.58 0 0 0-.064 1.158"
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const BurnIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
